import styled from 'styled-components';
import { Text, Tag, Action, Stack, theme, LeftArrowIcon } from '@veeqo/ui';
import { useAppContext } from 'context/Context';
import { Link } from 'react-router-dom';

interface TitleGroupProps {
  title: string;
  subtitle: string;
  isMobile?: boolean;
  tag?: string;
  showLoginReturnButton?: boolean;
  // Relative path back to the login index. Relative (not "/signin") so it resolves correctly
  // under both the /signin and /vq/sc/signin mounts. Defaults to the /verify depth.
  loginReturnPath?: string;
}

const GreenTag = styled(Tag)`
  background-color: ${theme.colors.secondary.green.light};
`;

const Container = styled(Stack) <{ isMobile: boolean }>`
  margin-top: ${({ isMobile }) => (isMobile ? theme.sizes[12] : theme.sizes[16])};
  margin-bottom: ${({ isMobile }) => (isMobile ? theme.sizes[6] : theme.sizes[11])};
`;

const TitleGroup = ({
  showLoginReturnButton,
  loginReturnPath = '..',
  title,
  subtitle,
  tag,
  isMobile = false,
}: TitleGroupProps) => {
  const { actions } = useAppContext();

  const resetLoginState = () => {
    actions.resetSignupData();
    actions.userNeedVerification(false);
  };

  return (
    <Container isMobile={isMobile}>
      {showLoginReturnButton &&
        <Action as={Link} to={loginReturnPath} replace appearance="link" onClick={resetLoginState}>
          <LeftArrowIcon />
          Back to login
        </Action>}
      {tag && (
        <GreenTag>
          <Text variant="bodySmall">{tag}</Text>
        </GreenTag>
      )}
      <Text variant="headingXL">{title}</Text>
      <Text variant="body">{subtitle}</Text>
    </Container>
  )
};

export default TitleGroup;
